// Client-side classification of hallucination rows per spec §6B.
// Cross-attribution is authoritative when flagged; otherwise a missing
// ground_truth means the value is fabricated; everything else is a direct
// contradiction of the recorded truth.

export function classifyHallucinationType(row) {
  // The redesigned RPC replaced the per-row `is_cross_attribution` boolean with
  // a `cross_attribution_count` on the per-fact row; accept either.
  if (row.is_cross_attribution === true || Number(row.cross_attribution_count) > 0) return 'cross_attribution';
  if (row.ground_truth == null) return 'fabricated';
  return 'contradicts';
}

export const HALLUCINATION_TYPE_LABELS = {
  fabricated: { label: 'Fabricated', emoji: '🚨' },
  contradicts: { label: 'Contradicts', emoji: '⚠️' },
  cross_attribution: { label: 'Cross-attribution', emoji: '🔀' },
};
